// Recordings From Scores Schema Are Slightly Different Than "Regular" Recordings
// This maps a recording from the scores schema to a regular recording
import { PublicRecording, Recording } from '@Entities/matching/recording-group-details'
import { secondsToDuration } from '@App/helpers/seconds-to-duration'
import { RecordingModel } from '@Entities/work/recording-model'

export const mapRecordingToRecordingModel = (recording: Recording | PublicRecording): RecordingModel => {
    const title =
        'recordingFullTitle' in recording
            ? recording.recordingFullTitle || recording.recordingTitle
            : recording.recordingTitle

    return {
        id: Number(recording.id),
        title,
        artistName: recording.recordingDisplayArtistName,
        isrc: recording.isrc,
        duration: secondsToDuration(parseInt(String(recording.duration), 10)),
        label: recording.label,
        dsp: recording.dsp,
        releaseDate: recording.releaseDate,
    }
}
